module.exports = __webpack_public_path__ + "static/media/Testimonio2.e0c3883a.png";